<h1 mat-dialog-title>Validation nécessaire</h1>
<div mat-dialog-content>
  {{data.subtitle}}
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>Non!</button>
  <button mat-button [mat-dialog-close]="true">Allez!</button>
</div>
